import { ReactNode } from 'react';
import { Box, SxProps, Typography } from '@mui/material';

interface SliderErrorProps {
  error: ReactNode;
  sx?: SxProps;
}

function SlidersError({ error, sx }: SliderErrorProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Typography color="error">{error}</Typography>
    </Box>
  );
}

export default SlidersError;
